import { Credit, Job, Payment } from '@kanda-libs/ks-frontend-services';

import { LenderStatus } from '../constants';

export const getEtikaState = (
  job: Job,
  credit: Credit,
  deposit?: Payment,
): LenderStatus => {
  const jobFinanceStatus = job?.finance_status || '';
  const financeStatus = credit?.state || '';
  if (
    [
      'paid',
      'payout_pending',
      'sat_note_signed',
      'sat_note_lender_review',
    ]?.includes(jobFinanceStatus)
  )
    return 'finished';
  if (jobFinanceStatus === 'sat_note_delayed') return 'sat_note_delayed';
  if (jobFinanceStatus?.startsWith('sat_note')) return 'sat_note';
  if (jobFinanceStatus === 'under_review') return 'under_review';
  if (jobFinanceStatus === 'finance_cancelled' || financeStatus === 'cancelled')
    return 'cancelled';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'action_customer'
  )
    return 'sign_documents';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'referred'
  )
    return 'referred';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'declined'
  )
    return 'declined';
  if (
    jobFinanceStatus === 'applied_for_finance' &&
    financeStatus === 'accepted'
  )
    return 'sign_documents';
  if (jobFinanceStatus === 'applied_for_finance' && financeStatus === 'pending')
    return 'sign_documents';

  if (jobFinanceStatus === 'finance_not_approved') return 'not_approved';
  if (
    jobFinanceStatus === 'financed' &&
    deposit?.payment_option?.payment_method === 'cash'
  )
    return 'ready_to_start';
  if (jobFinanceStatus === 'financed' && deposit?.status === 'paid')
    return 'ready_to_start';
  if (jobFinanceStatus === 'financed' && deposit?.status === 'unpaid')
    return 'deposit';
  return 'loading';
};
